import Basic2 from './Basic2'
export default Basic2
